// extracted by mini-css-extract-plugin
export var brand = "_3u-8";
export var compact = "_3u-5";
export var extraSmall = "_3u-6";
export var icon = "_3u-0";
export var large = "_3u-3";
export var light = "_3u-1";
export var medium = "_3u-4";
export var outline = "_3u-a";
export var primaryDark = "_3u-9";
export var primaryLight = "_3u-7";
export var primaryModern = "_3u-b";
export var success = "_3u-2";